// extracted by mini-css-extract-plugin
export var art = "SkrillStatusStep-module--art--29bd8";
export var container = "SkrillStatusStep-module--container--b95b1";
export var title = "SkrillStatusStep-module--title--9f549";